import { FunctionComponent } from 'react';
import cn from 'classnames';
import styles from './Header.module.css';
import {Image} from 'react-bootstrap';
import NotificationArea from './component/NotificationArea/NotificationArea';
import { ASSESTS } from '../../../constant/assest';

interface IHeaderProps {
    menuClick: (e: React.MouseEvent) => void;
    className?: string;
}

const Header: FunctionComponent<IHeaderProps> = ({ menuClick, className }) => {
    return (
        <header className={cn(styles.header, className)}>
            <div className={styles.headerRow}>
                <div className={cn(styles.headerLeft)}>
                    <NotificationArea 
                        menuClick={menuClick} 
                    />
                </div>
                <div className={styles.headerRight}>
                    <Image 
                        src={ASSESTS.LOGO}
                        width={291}
                        height={73}
                        alt="Fishinity"
                    />
                </div>
            </div>
        </header>
    );
};

export default Header;
